import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { INotificationResponseModel } from 'src/app/modules/notifications/interfaces/notification-response-model';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'app-notifications-list-view',
    templateUrl: './notifications-list-view.component.html',
    styleUrls: ['./notifications-list-view.component.scss']
})
export class NotificationsListViewComponent implements OnInit {
    @Input() notifications: Array<INotificationResponseModel>;
    @Output() toggleReadNotificationEvent =
        new EventEmitter<INotificationResponseModel>();
    @Output() notificationViewEvent =
        new EventEmitter<INotificationResponseModel>();
    @Output() notificationsScrollDownEvent = new EventEmitter<void>();

    constructor(private notificationService: NotificationService) {}

    ngOnInit() {}

    public get scrollLoading$(): Observable<boolean> {
        return this.notificationService.scrollLoading$;
    }

    public toggleReadNotification(
        notification: INotificationResponseModel
    ): void {
        if (notification) {
            this.toggleReadNotificationEvent.emit(notification);
        }
    }

    public onViewNotification(notification: INotificationResponseModel): void {
        if (notification) {
            this.notificationViewEvent.emit(notification);
        }
    }

    public onScrollDownThreshold(): void {
        this.notificationsScrollDownEvent.emit();
    }
}
